export default {
  namespaced: true,
  state: {
    listParams: null,
    searchInit: null,
    searchParams: null,
    pageInit: null,
    pageParams: null
  },
  mutations: {
    INIT(state) {
      state.listParams = Object.assign({}, state.searchInit, state.pageInit)
    },
    INIT_SEARCH_PARAMS(state, data) {
      state.searchInit = data
    },
    INIT_PAGE_PARAMS(state, data) {
      state.pageInit = data
    },
    SET_SEARCH_PARAMS(state, params) {
      state.searchInit.keys().forEach(key => {
        state.listParams[key] = params[key]
      })
      state.listParams = Object.assign(state.listParams, state.pageInit)
    },
    SET_PAGE_PARAMS(state, params) {
      state.pageInit.keys().forEach(key => {
        state.listParams[key] = params[key]
      })
    }
  },
  getters: {
    listParams: (state, getters) => {
      return state.listParams
    },
    initData: (state, getters) => searchOptions => {
      let obj = {}
      searchOptions.forEach((option, index) => {
        Object.keys(option.defaultSettings).forEach(key => {
          obj[key] = option.defaultSettings[key]
        })
      })
      return obj
    }
  }
}
